/**
 * Grenzen fuer Dateianhaenge.
 *
 * Anhaenge wandern in die Sicherung mit. Das ist eine bewusste Entscheidung:
 * eine Datenkategorie, die das Backup stillschweigend auslaesst, waere ein
 * Rueckschritt gegen das Kernversprechen der App - eine Datei, die alles
 * enthaelt.
 *
 * Der Preis: die Sicherung ist JSON, Bytes muessen also als Base64 hinein und
 * werden dabei rund ein Drittel groesser. Ohne Grenzen waere die Sicherung
 * irgendwann so gross, dass der Browser sie nicht mehr als einen String bauen
 * kann - und dann gaebe es GAR KEINE Sicherung mehr. Deshalb lieber eine
 * sichtbare Grenze als ein stilles Scheitern.
 */

/** Groesste einzelne Datei: 10 MB. Skript oder Folien ja, Videosammlung nein. */
export const MAX_FILE_BYTES = 10 * 1024 * 1024;

/** Ab hier warnt die Oberflaeche sichtbar: 100 MB ueber alle Anhaenge. */
export const WARN_TOTAL_BYTES = 100 * 1024 * 1024;

/** Base64 braucht vier Zeichen je drei Bytes. */
export const BASE64_FACTOR = 4 / 3;

export type AttachmentLoad = 'ok' | 'viel' | 'kritisch';

export function isFileTooLarge(size: number): boolean {
  return size > MAX_FILE_BYTES;
}

/** Wie gross wird die Sicherung durch die Anhaenge ungefaehr? */
export function backupSizeEstimate(totalBytes: number): number {
  return Math.round(totalBytes * BASE64_FACTOR);
}

export function attachmentLoad(totalBytes: number): AttachmentLoad {
  if (totalBytes >= WARN_TOTAL_BYTES * 2) return 'kritisch';
  if (totalBytes >= WARN_TOTAL_BYTES) return 'viel';
  return 'ok';
}

/** `'1,4 MB'` - deutsche Schreibweise mit Komma. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${runde(kb)} kB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${runde(mb)} MB`;
  return `${runde(mb / 1024)} GB`;
}

function runde(n: number): string {
  // Unter 10 eine Nachkommastelle, darueber keine - "1,4 MB", aber "230 MB".
  const gerundet = n < 10 ? Math.round(n * 10) / 10 : Math.round(n);
  return String(gerundet).replace('.', ',');
}
